// @flow
import React, { Component } from 'react';

type Props = {||};
type State = {|
    Component: any,
    mounted: boolean,
|};

export default class SendSellerMessageModalLoader extends Component<Props, State> {
    state = {
        Component: null,
        mounted: false,
    };

    componentDidMount() {
        return new Promise(resolve => {
            import(/* webpackChunkName: "SendSellerMessageModal" */ './SendSellerMessageModalContainer').then(mod =>
                resolve(mod.default)
            );
        }).then(container => {
            this.setState({ Component: container, mounted: true });
        });
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    render() {
        const { Component, mounted } = this.state;
        return mounted && Component !== null ? <Component /> : null;
    }
}
